import { Send } from 'lucide-react';
import { getOverdueInfo, getCustomerUpdateFreshness, formatDate, calculateAge } from './companiesHelpers';
import { normalizeStatus } from '../../utils/claimHelpers';

/** Render the value for a given column id. Pure presentational. */
export default function CompanyClaimCell({ claim, colId, activeLossType, claimFreqDays }) {
  switch (colId) {
    case 'report_no': {
      const info = getOverdueInfo(claim, claimFreqDays);
      const freshness = getCustomerUpdateFreshness(claim.last_customer_update_at);
      return (
        <span className="flex items-center gap-1.5">
          <span className="font-medium text-blue-600">{claim.report_no}</span>
          {info && (
            <span
              className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold leading-none whitespace-nowrap ${
                info.type === 'overdue' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'
              }`}
              data-testid={`overdue-badge-${claim.report_no}`}
            >
              {info.label}
            </span>
          )}
          {freshness && (
            <span
              className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] font-semibold leading-none whitespace-nowrap bg-teal-50 text-teal-700 border border-teal-200"
              title={`Last customer update sent ${freshness.absolute}`}
              data-testid={`last-update-badge-${claim.report_no}`}
            >
              <Send className="w-2.5 h-2.5" />
              {freshness.label}
            </span>
          )}
        </span>
      );
    }
    case 'date_of_loss':         return formatDate(claim.date_of_loss);
    case 'truck_no':             return claim.truck_no || '-';
    case 'trailer_no':           return claim.trailer_no || '-';
    case 'drivers_name':         return claim.drivers_name || '-';
    case 'drivers_ph_no':        return claim.drivers_ph_no || '-';
    case 'fault':
      return (
        <span className={`px-2 py-1 rounded text-xs font-medium ${
          claim.fault === 'At Fault' ? 'bg-red-100 text-red-700' :
          claim.fault === 'Not At Fault' ? 'bg-green-100 text-green-700' :
          'bg-gray-100 text-gray-700'
        }`}>
          {claim.fault || 'Unknown'}
        </span>
      );
    case 'age':                  return calculateAge(claim.date_of_loss);
    case 'updated_at':           return formatDate(claim.updated_at);
    case 'update_age':           return calculateAge(claim.updated_at);
    case 'created_at':           return formatDate(claim.created_at);
    case 'location':             return claim.location || '-';
    case 'description':          return <span className="truncate max-w-[150px] block">{claim.description || '-'}</span>;
    case 'status': {
      const typeStatus = claim.type_data?.[activeLossType]?.status || claim.status || '-';
      return normalizeStatus(typeStatus);
    }
    case 'police_involved':      return claim.police_involved === true ? 'Yes' : claim.police_involved === false ? 'No' : '-';
    case 'other_vehicle_involved': return claim.other_vehicle_involved || '-';
    case 'injury':               return claim.injury ? 'Yes' : 'No';
    case 'tow_away':             return claim.tow_away ? 'Yes' : 'No';
    case 'fatality':             return claim.fatality ? 'Yes' : 'No';
    default:                     return '-';
  }
}
